import logger from "../../../utils/logger";

export function GenerateFormattedDate(date) {
  try {
    // tarih değerlerini ayrıştırın

    const day = date?.getDate().toString().padStart(2, "0");
    const month = (date?.getMonth() + 1).toString().padStart(2, "0");
    const year = date?.getFullYear();
    // Sabit saat, dakika, saniye ve milisaniye değerlerini sıfır olarak ekleyin.
    return `${year}-${month}-${day}T00:00:00.000+00:00`;
  } catch (error) {
    logger.error("Tarih formatlanırken bir hata oluştu:", error);
    return null;
  }
}
